module.exports = "/static/media/glyphicons-halflings-regular.89889688.svg";